import { render, staticRenderFns } from "./Grid2.vue?vue&type=template&id=5b7e974a&scoped=true"
import script from "./Grid2.vue?vue&type=script&lang=ts"
export * from "./Grid2.vue?vue&type=script&lang=ts"
import style0 from "./Grid2.vue?vue&type=style&index=0&id=5b7e974a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7e974a",
  null
  
)

export default component.exports